import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type PartnerAccountTransfer = {
  label: string;
  id: vp.PartnerAccountTransferId;
  require: boolean;
  visible: () => boolean;
  getSelectOptions: () => { [key: string]: string };
  type: 'input' | 'select' | 'textarea';
  placeholder?: string | undefined;
  preset: keyof vp.TextFieldPresets | undefined;
  disabled: boolean;
  searchCallback?: (searchTerm: string) => void;
};

const CurrencyOptions = {
  ...vp.CURRENCY_SELECT_OPTIONS,
};

const TransferTypeOptions = {
  ...vp.TRANSFER_TYPE_SELECT_OPTIONS,
};

export const useBuildPartnerAccountTransfer = (
  fromAccountDetails: { [key: string]: string },
  toAccountDetails: { [key: string]: string },
  isDisabled: boolean,
  onFromAccountSearch?: (searchTerm: string) => void,
  onToAccountSearch?: (searchTerm: string) => void,
): PartnerAccountTransfer[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'PartnerAccountTransfer' });
  return [
    {
      label: t('transferTypeIDLabel'),
      id: vp.PartnerAccountTransferId.TransferTypeID,
      getSelectOptions: () => TransferTypeOptions,
      require: true,
      disabled: isDisabled,
      preset: 'text',
      type: 'select',
      placeholder: t('transferTypeIDPlaceholder'),
      visible: () => true,
    },
    {
      label: t('debitorAccountIDLabel'),
      id: vp.PartnerAccountTransferId.DebitorAccountID,
      getSelectOptions: () => fromAccountDetails,
      require: true,
      disabled: isDisabled,
      preset: 'text',
      type: 'select',
      placeholder: t('debitorAccountIDPlaceholder'),
      visible: () => true,
      searchCallback: onFromAccountSearch,
    },
    {
      label: t('recipientAccountIDLabel'),
      id: vp.PartnerAccountTransferId.RecipientAccountID,
      require: true,
      disabled: isDisabled,
      preset: 'text',
      getSelectOptions: () => toAccountDetails,
      type: 'select',
      placeholder: t('recipientAccountIDPlaceholder'),
      visible: () => true,
      searchCallback: onToAccountSearch,
    },
    {
      label: t('currencyLabel'),
      id: vp.PartnerAccountTransferId.Currency,
      getSelectOptions: () => CurrencyOptions,
      require: true,
      disabled: isDisabled,
      preset: 'text',
      type: 'select',
      placeholder: t('currencyPlaceholder'),
      visible: () => true,
    },
    {
      label: t('amountLabel'),
      id: vp.PartnerAccountTransferId.Amount,
      getSelectOptions: () => ({}),
      require: true,
      disabled: isDisabled,
      preset: 'text',
      type: 'input',
      placeholder: t('amountPlaceholder'),
      visible: () => true,
    },
    {
      label: t('clientReferenceNumberLabel'),
      id: vp.PartnerAccountTransferId.ClientReferenceNumber,
      getSelectOptions: () => ({}),
      require: false,
      disabled: isDisabled,
      preset: 'text',
      type: 'input',
      placeholder: t('clientReferenceNumberPlaceholder'),
      visible: () => true,
    },
    {
      label: t('notesLabel'),
      id: vp.PartnerAccountTransferId.Notes,
      getSelectOptions: () => ({}),
      require: false,
      disabled: isDisabled,
      preset: 'text',
      type: 'textarea',
      placeholder: t('notesPlaceholder'),
      visible: () => true,
    },
  ];
};
